import React from 'react';
import Header from './cotacao-header';
import Items from './cotacao-itens';
import ctrl from 'controllers/cotacao-ctrl';
import Button from 'components/button';

module.exports = React.createClass({

  render(){
    var content;


    if (ctrl.data == undefined || ctrl.data.temCotacao == undefined) {
      content = (<div className="well"><h3>Aguarde, carregando dados...</h3></div>);
    } else if (ctrl.data.temCotacao) {
      content = (
        <div>
          <Header />
          <Items />
        </div>
      );
    } else {
      content = (<div className="well">
        <h3>Não existe cotação em andamento</h3>
      </div>);
    }

    return (
      <div>
        {content}
      </div>
    );
  }

});


/** WEBPACK FOOTER **
 ** ./src/views/cotacao/cotacao.js
 **/